/**
 * Trimmed text for any value: null/undefined become "", anything else is turned
 * into a string first. Use it instead of `value?.trim()` on values that come from
 * the server or from state, which are not always strings (an AI reply of `false`
 * used to crash the SOAP Notes page with "trim is not a function").
 */
export const toText = (value) => String(value ?? '').trim();

/** True for a string with something other than whitespace in it. */
export const isNonEmptyText = (value) => typeof value === 'string' && value.trim() !== '';
